import initData from 'init-data';
import { createSlice } from '@reduxjs/toolkit';
import userData from 'tradera-apps/syi/script/app_react/services/user-data';
import { getSyiSlice } from 'tradera-state/views/syi/selectors/syi';

const defaultRegionValue = 'EU';
let availableAllowedBuyerRegions;
let defaultBuyerRegion;
let initialState;

const initModuleGlobals = () => {
    if (
        !initData.pageSpecificData ||
        !initData.pageSpecificData.allowedBuyerRegions
    ) {
        return null;
    }

    availableAllowedBuyerRegions =
        initData.pageSpecificData.allowedBuyerRegions;
    defaultBuyerRegion = availableAllowedBuyerRegions.find(
        r => r.value === defaultRegionValue
    );

    initialState = {
        availableAllowedBuyerRegions: availableAllowedBuyerRegions,
        selectedBuyerRegion: defaultBuyerRegion.value,
        selectedBuyerRegionText: defaultBuyerRegion.text,
        availableAllowedBuyerRegionsForEditWithBids: false,
        isSetAllowedBuyerRegionToAtLeastEuEnabled:
            initData &&
            initData.featureSwitches &&
            initData.featureSwitches[
                'international-shipping-schenker-eu-default'
            ],
        isTraderaPayEnabled: userData.payment.isTraderaPayEnabled
    };
};

initModuleGlobals();
const buyerRegionSlice = createSlice({
    name: 'buyer-region',
    initialState: initialState,
    reducers: {
        setAllowedBuyerRegion: (state, action) => {
            const region = availableAllowedBuyerRegions.find(
                r => r.value === action.payload.allowedBuyerRegion
            );
            const { value, text } = region || defaultBuyerRegion;
            state.selectedBuyerRegion = value;
            state.selectedBuyerRegionText = text;

            return state;
        },
        setAvailableAllowedBuyerRegions: (state, action) => {
            state.availableAllowedBuyerRegions =
                action.payload.availableRegions;
            state.availableAllowedBuyerRegionsForEditWithBids = true;
            return state;
        }
    }
});

export const setAvailableAllowedBuyerRegions = () => (dispatch, getState) => {
    const draftState = getSyiSlice(getState()).draft;
    const regionState = getSyiSlice(getState()).buyerRegion;
    const regions = regionState.availableAllowedBuyerRegions;
    const selectedRegion = regionState.selectedBuyerRegion;
    const filters = {
        Sweden: region =>
            ['Sweden', 'Nordic', 'EU', 'International'].indexOf(region.value) >
            -1,
        Nordic: region =>
            ['Nordic', 'International'].indexOf(region.value) > -1,
        EU: region => ['EU', 'International'].indexOf(region.value) > -1,
        International: region => ['International'].indexOf(region.value) > -1
    };
    const useFilter = draftState.draftReason === 'ChangeItemWithBids';
    const filter = (useFilter && filters[selectedRegion]) || (() => true);
    const availableRegions = regions.filter(filter);
    dispatch(
        buyerRegionSlice.actions.setAvailableAllowedBuyerRegions({
            availableRegions
        })
    );
};

export const { setAllowedBuyerRegion } = buyerRegionSlice.actions;

export default buyerRegionSlice.reducer;
